import React from "react";
import Icon from "./Icon";
import ScreenLayout from "./ScreenLayout";

const TONES = {
  brand: "bg-qv-brand-50 text-qv-brand",
  danger: "bg-qv-red-50 text-qv-red",
  warning: "bg-qv-amber-50 text-qv-amber",
};

// Écrans transverses centrés (chargement, borne non éligible, erreur, page
// introuvable, lien invalide) : pictogramme, titre, texte, puis les actions.
export default function StatusScreen({ loading = false, icon, image, tone = "brand", title, text, children }) {
  return (
    <ScreenLayout>
      <div
        className={`flex flex-1 flex-col items-center justify-center text-center ${loading ? "md:py-10" : "md:py-2"}`}
        role={loading ? "status" : undefined}
        aria-live="polite"
      >
        {loading ? (
          <div className="relative h-24 w-24" aria-hidden="true">
            <div className="absolute inset-0 rounded-full border-[6px] border-qv-brand-100" />
            <div className="absolute inset-0 rounded-full border-[6px] border-transparent border-t-qv-brand animate-spin" />
          </div>
        ) : (
          <div className={`h-16 w-16 rounded-full flex items-center justify-center ${TONES[tone]}`}>
            {image ? <img src={image} alt="" className="h-9 w-9" /> : <Icon name={icon} size={32} />}
          </div>
        )}
        <h1
          className={`mb-2 text-[26px] leading-[34px] tracking-[-.02em] font-bold ${
            loading ? "mt-8" : "mt-5 md:text-[28px] md:leading-9"
          }`}
        >
          {title}
        </h1>
        {text && <p className="text-[15px] leading-6 text-qv-muted">{text}</p>}
        {children && <div className="mt-7 flex w-full flex-col items-center gap-2.5">{children}</div>}
      </div>
    </ScreenLayout>
  );
}
